<script>
import { mapGetters } from 'vuex'

import ManageOrder from '@components/e-shop/manage-order.vue'
import InfoOrder from '@components/e-shop/info-order.vue'
import Spinner from '@components/spinner.vue'

import Translatable from '@src/mixins/translatable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'

export default {
  components: {
    ManageOrder,
    InfoOrder,
    Spinner
  },
  mixins: [
    Translatable,
    SanitizerMixin,
  ],
  computed: {
    ...mapGetters('eShop', [
      'orderData',
      'loader'
    ]),
    queryData() {
      const query = this.$route.query
      return {
        session_id: query.session_id,
        type: query.type,
      }
    }
  },
}
</script>

<template>
  <section class="calculator-section justify-center">
    <div v-if="loader" class="loader-container">
      <Spinner />
    </div>
    <div v-else class="container">
      <ManageOrder v-if="queryData.type === 'manage'" />
      <InfoOrder v-else />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@design';

.loader-container {
  height: 50vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  min-height: 50vh;
}

@media only screen and (max-width: $screen-width-xs) {
}
</style>
